import {TabellaAziendaBase} from "@commons/mapping/TabellaAziendaBase";
import {GiustificazioneAutoRecord} from "@commons/mapping/GiustificazioneAutoRecord";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export interface TabellaGiustAutoRecord extends TabellaAziendaBase {
    enabled: boolean;
    conta: number;
    regole: GiustificazioneAutoRecord[];
}

export class TabellaGiustAutoRecord {

    static factory: ObjectFactory<TabellaGiustAutoRecord> = (json?) => {
        return merge<TabellaGiustAutoRecord, Partial<TabellaGiustAutoRecord> | undefined>({
            idAziendaTabelle: 0,
            idTabella: 0,
            descrizione: '',
            enabled: false,
            conta: 0,
            regole: [],
            URI: null
        }, json);
    }


    static usaGiu(that: TabellaGiustAutoRecord, codGiu: string | null) {
        for (var indGiu = 0; indGiu < that.regole.length; ++indGiu) {
            if (codGiu === that.regole[indGiu].codGiu) {
                return true;
            }
        }

        return false;
    }
}
